<template>
  <div>
    <div class="card-body">
      <table class="table table-sm table-bordered">
        <thead class="bg-custom">
          <tr>
            <th width="10%">Name</th>
            <th width="10%">CNIC/Passport No</th>
            <th width="10%">Designation</th>
            <th width="10%">BOR Y/N</th>
            <th width="10%">Status Y/N</th>
            <th width="5%">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in records" :key="index">
            <td>
              <input v-model="record.BO_NAME" type="text" class="table-input" />
            </td>
            <td>
              <input v-model="record.BO_CNICPASSNO" type="text" maxlength="13" minlength="5" pattern="[0-9]{5,13}" class="table-input" />
            </td>
            <td>
              <input v-model="record.BO_DESIGNATION" type="text" class="table-input" />
            </td>
            <td>
              <select v-model="record.BO_BORYN" class="table-input">
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </select>
            </td>
            <td>
              <select v-model="record.BO_STATUS" class="table-input">
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </select>
            </td>
            <td>
              <button class="btn btn-danger btn-sm" @click="deleteRecord(index)"><i class="fas fa-trash" /></button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="10">
              <button class="btn btn-block btn-secondary" type="button" @click="openModal">Add New</button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>


    <div class="card-footer">
      <button class="btn btn-success float-right mr-1" @click="submitForm">Submit</button>
    </div>

    <div class="modal fade show" data-backdrop="static" id="addEntryModal" aria-modal="true" role="dialog">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-custom">
            <h4 class="modal-title">Add Signatory Detail</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" style="color:white">×</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label class="form-label">Name</label>
                <input v-model="newRecord.BO_NAME" type="text" class="form-control" />
              </div>
              <div class="mb-3">
                <label class="form-label">CNIC/NICOP/PASSPORT</label>
                <input v-model="newRecord.BO_CNICPASSNO" type="text" maxlength="13" minlength="5" pattern="[0-9]{5,13}" class="form-control" />
              </div>
              <div class="mb-3">
                <label class="form-label">DESIGNATION</label>
                <input v-model="newRecord.BO_DESIGNATION" type="text" class="form-control" />
              </div>
              <div class="mb-3">
                <label class="form-label">BOR Yes/No</label>
                <select v-model="newRecord.BO_BORYN" class="form-control">
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">Status Yes/No</label>
                <select v-model="newRecord.BO_STATUS" class="form-control">
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="addRecord">Add Entry</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Modal } from 'bootstrap';

  export default {
    props: {
      clientid: Number,
    },
  data() {
    return {
      records: [],
      newRecord: {
        BP_ID: this.clientid,
        BO_NAME: '',
        BO_CNICPASSNO: '',
        BO_DESIGNATION: '',
        BO_BORYN: '',
        BO_STATUS: '',
        BO_ISBENIFICIARY: 'N',
        BO_ISDIRECTOR: 'N',
        BO_ISSIGNATORY: 'Y',
      },
    };
    },
    created() {
      this.pageLoad();
    },
    methods: {
      pageLoad() {
        var vm = this;
        axios.get("/api/UICApi/pageLoadSignatory?ID=" + this.clientid)
          .then(function (res) {
            vm.records = res.data.records;
          })
          .catch((error) => {
            console.log(error);
            toastr.error("Failed to Signatory Ownership data.");
          });
      },
    openModal() {
      this.newRecord = {
        BP_ID: this.clientid,
        BO_NAME: '',
        BO_CNICPASSNO: '',
        BO_DESIGNATION: '',
        BO_BORYN: '',
        BO_STATUS: '',
        BO_ISBENIFICIARY: 'N',
        BO_ISDIRECTOR: 'N',
        BO_ISSIGNATORY: 'Y',
      };
      $("#addEntryModal").modal("show");
    },
      addRecord() {
        if (this.newRecord.BO_NAME && this.newRecord.BO_CNICPASSNO && this.newRecord.BO_DESIGNATION && this.newRecord.BO_BORYN && this.newRecord.BO_STATUS) {
          this.records.push({ ...this.newRecord });
          $("#addEntryModal").modal("hide");
      } else {
          toastr.error('Please fill in required fields');
      }
    },
    deleteRecord(index) {
      if (confirm('Are you sure you want to delete this record?')) {
        this.records.splice(index, 1);
      }
    },
    submitForm(e) {
      var vm = this;
      e.preventDefault();
      startReq();
      axios.post('/api/UICApi/SaveSignatory', {
        records: vm.records,
      })
        .then(response => {
          endReq();
          if (response.data.status) {
            toastr.success(response.data.msg)
            vm.clearForm();
          }
          else {
            toastr.error(response.data.msg)
          }
        })
        .catch(error => {
          endReq();
          vm.error = 'Error saving Signatory';
          console.log(error);
        })
    }
  }
};
</script>

<style scoped>
  .info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 20px;
  }

  .info-field {
    display: flex;
    flex-direction: column;
  }

  .table td {
    padding: 4px !important; 
    vertical-align: middle;
  }

  .table-input {
    width: 100%;
    height: 30px;
    padding: 2px 6px;
    margin: 0;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 13px;
  }


  @media (max-width: 768px) {
    .table-input {
      font-size: 0.95rem;
      padding: 0.4rem 0.6rem;
    }

    .table th, .table td {
      font-size: 0.95rem;
      padding: 0.4rem 0.6rem;
    }
  }

  .info-input {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/Signatory.vue